//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import log from './log';
import { isPrerendering } from './prerender';

const GA = {
  pageview: () => {
    if (isPrerendering()) return;

    if (process.env.REACT_APP_ENV !== 'prod'){
      //return;
    }

    ReactGA.initialize(process.env.REACT_APP_GA4);
    //ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  },
  track: (e) => {
    if (isPrerendering()) return;

    log.trace(e);

    if (process.env.REACT_APP_ENV !== 'prod'){
      //return;
    }

    //ReactGA.initialize('UA-166037494-1');
    ReactGA.initialize(process.env.REACT_APP_GA4)
    
    // if conversion event
    if (e.action.startsWith('onPaymentSuccess_Stripe')){
      log.traceTag('send onPaymentSuccess_Stripe event', e)
      ReactGA.event(
        e.action, {
          value: e.value
        })
      return;
    }

    // is custom event
    ReactGA.event({
      category: e.category,
      action: e.action,
      label: e.label,
      value: e.value
    });
  }
}

export default GA;
